import type { StepOptionsButton } from 'shepherd.js'

/**
 * Canonical step buttons. Use these instead of inlining `{ text, action }` —
 * stops copy drift across tours ("Got It" / "Got it" / "I got it") and makes
 * the last-step contract (Finish calls complete(), not next()) impossible to
 * get wrong.
 */
export const back: StepOptionsButton = {
  text: 'Back',
  classes: 'shepherd-button-secondary',
  action() { return this.back() },
}

export const next: StepOptionsButton = {
  text: 'Next',
  action() { return this.next() },
}

export const gotIt: StepOptionsButton = {
  text: 'Got it',
  action() { return this.next() },
}

export const finish: StepOptionsButton = {
  text: 'Finish',
  action() { return this.complete() },
}
